// Logo da Pick'n Go, usada na tela de configuração e no painel (recebedor).
export const PICKNGO_LOGO_URL =
    "https://clientefiel.s3.us-east-1.amazonaws.com/images/icon-app-pickngo.png"
